import SectionHeading from './SectionHeading';
import { photoItems } from '@/mocks/home';

export default function PhotoGrid() {
  return (
    <section id="gallery" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="PICTURE STORIES"
          title="图文精选"
          desc="图文并重，画面和文字一样有信息量。挑几张今天被转发最多的内容给你。"
          action={{ label: '查看更多图文', href: '#gallery' }}
        />

        <div className="mt-8 columns-1 gap-5 sm:columns-2">
          {photoItems.map((item) => (
            <article
              key={item.id}
              className="group relative mb-5 break-inside-avoid overflow-hidden rounded-lg border border-background-200/80 bg-background-200"
            >
              <div className={`w-full overflow-hidden ${item.tall ? 'h-72 md:h-80' : 'h-52 md:h-56'}`}>
                <img
                  src={item.image}
                  alt={item.title}
                  title={`${item.title} - 免费看料图文精选`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/15 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <span className="inline-flex rounded-sm bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-background-950">
                  {item.tag}
                </span>
                <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-background-50 md:text-lg">
                  {item.title}
                </h3>
                <div className="mt-2 flex items-center gap-4 text-xs text-background-100/85">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-heart-3-line text-sm"></i>
                    {item.likes}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-chat-3-line text-sm"></i>
                    讨论中
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}